import React from "react";
import Title from "../title";
import styled from "styled-components";
import background from '../../assets/mac.jpg';
import {BorderGradient} from "../../styles/globalStyles";
import {device} from "../../styles/breakpoints";


const StyledVideoDiv = styled(BorderGradient)`
  width: 100%;
  height: 300px;
  background-image: url(${background}),
  linear-gradient(to right, #00F0FF, #5773FF, #FF007A);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 30px;
  @media ${device.desktop} {
    width: 60%;
    height: 400px;
  }
`;


const VideoSection = () => (
  <>
    <Title h1='Your Writing Partner!' h3="Let's introduce with">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      Maecenas purus odio tempor rutrum...
    </Title>
    <StyledVideoDiv/>
  </>
);

export default VideoSection;
